export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=706cc0fa511fcb724c901d68d7c864ce541ef633aa&name=pushAdClickData!'